import React from 'react';
// import cx from 'classnames';
import PropTypes from 'prop-types';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import InlineAdvertsBlock from 'desktop/components/InlineAdvertsBlock/InlineAdvertsBlock';
// import { fetchVipCars } from 'shared/helpers/search';
import { withFetch } from 'shared/hocs/withFetch';
// import Button from 'shared/components/UI/Button/Button';
import { FormattedMessage } from 'react-intl';

import Link from 'shared/components/Link/Link';

import s from './LeasingSpecialPropositions.css';

class SpecialPropositions extends React.Component {
  static propTypes = {
    specialCars: PropTypes.arrayOf(PropTypes.shape()).isRequired,
    searchLink: PropTypes.string,
    // news: PropTypes.arrayOf(PropTypes.shape()).isRequired,
    // fetch: PropTypes.func.isRequired,
  };
  static defaultProps = {
    searchLink: '/avto/',
  };

  render() {
    return (
      <div className={s.root}>
        <div>
          <InlineAdvertsBlock
            items={this.props.specialCars}
            rows={2}
            // lensEvent={lensEvent}
            itemsInLine={4}
          />
          <Link className={s.searchBtn} to={this.props.searchLink}>
            <FormattedMessage id={'Показать все'} />
          </Link>
        </div>
      </div>
    );
  }
}

export default withStyles(s)(withFetch(SpecialPropositions));



// WEBPACK FOOTER //
// ./src/shared/components/Article/Leasing/LeasingSpecialPropositions/LeasingSpecialPropositions.js